/* Crater theme JS — no dependencies. */
(function () {
  'use strict';
  var C = window.Crater || { currency: 'USD', routes: { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart' } };

  function money(cents) {
    var v = cents / 100;
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: C.currency, minimumFractionDigits: v % 1 === 0 ? 0 : 2 }).format(v);
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var btn = $('[data-close].icon-btn', d);
    if (btn) setTimeout(function () { btn.focus(); }, 50);
    return true;
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (open && openDrawer(open.getAttribute('data-open'))) { e.preventDefault(); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart rendering ---------- */
  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-cart-panel]', doc);
    var panel = $('#cart-drawer [data-cart-panel]');
    if (fresh && panel) {
      panel.innerHTML = fresh.innerHTML;
      panel.setAttribute('data-count', fresh.getAttribute('data-count'));
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = fresh.getAttribute('data-count');
        el.setAttribute('data-count', fresh.getAttribute('data-count'));
      });
    }
  }
  function changeLine(line, qty) {
    return fetch(C.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty) || 0), sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if ($('[data-cart-page]')) { window.location.reload(); return; }
      renderCart(cart.sections);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    changeLine(b.getAttribute('data-qty-change'), b.getAttribute('data-qty'));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(input.getAttribute('data-qty-input'), input.value);
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    var jsonEl = $('[data-product-json]', root.parentNode || document);
    if (!form || !jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add]', form);
    var addLabel = $('[data-add-label]', form);
    var errorEl = $('[data-error]', form);
    var qtyInput = $('[data-qty]', form);
    var sticky = $('[data-sticky-buy]');
    var gallery = $('[data-gallery]', root);

    function selectedOptions() {
      return $$('.opt', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var opts = selectedOptions();
      $$('.opt', form).forEach(function (fs, i) { var l = $('[data-option-label]', fs); if (l) l.textContent = opts[i]; });
      var v = findVariant(opts);
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      $$('[data-price]', root).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-compare]', root).forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (sticky) {
        $('[data-sticky-price]', sticky).textContent = money(v.price);
        $('[data-sticky-add]', sticky).disabled = !v.available;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.media_id && gallery) {
        var slide = $('[data-media-id="' + v.media_id + '"]', gallery);
        if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      }
    }
    $$('.opt input', form).forEach(function (input) { input.addEventListener('change', update); });

    /* Free-shipping add-ons: price follows the chosen option; picking an option ticks the row */
    $$('select[data-bundle-variant]', form).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex], row = sel.closest('.bundle__item');
        $('[data-bundle-price]', row).textContent = o.getAttribute('data-price');
        $('[data-bundle-compare]', row).textContent = o.getAttribute('data-compare');
        $('[data-bundle-check]', row).checked = true;
      });
    });

    $$('[data-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.getAttribute('data-step')));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      errorEl.hidden = true;
      addBtn.disabled = true;
      var items = [{ id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }];
      var extras = $$('[data-bundle-check]', form).filter(function (cb) { return cb.checked; });
      extras.forEach(function (cb) {
        var v = $('[data-bundle-variant]', cb.closest('.bundle__item'));
        if (v && v.value) items.push({ id: Number(v.value), quantity: 1 });
      });
      fetch(C.routes.cartAdd, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer' })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) { errorEl.textContent = res.body.description || res.body.message || 'Could not add to bag.'; errorEl.hidden = false; return; }
          extras.forEach(function (cb) { cb.checked = false; });
          renderCart(res.body.sections);
          openDrawer('cart-drawer');
        })
        .catch(function () { addBtn.disabled = false; form.submit(); });
    });

    /* Gallery thumbs */
    if (gallery) {
      var thumbs = $$('[data-thumb]', root);
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var slide = gallery.children[Number(t.getAttribute('data-thumb'))];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        });
      });
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }, { passive: true });
    }

    /* Sticky add-to-bag on mobile */
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    var s = $('[data-sort]');
    if (!s) return;
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    var el = $('[data-recommendations]');
    if (!el || el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-product-section]').forEach(initProduct);
    initSort();
    initRecs();
  });
})();
